import React, { Component } from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  Button,
  CardHeader,
  UncontrolledAlert,
  CardBody,
  ModalBody,
  ModalHeader,
  Modal,
  CardImg,
} from "reactstrap";
import { MdAdd } from "react-icons/md";
import Formsy from "formsy-react";
import { Spinner } from "../../Shared";
import { TextInput } from "../../Shared/Forms";
import MetricsDropDown from "../Metrics/MetricsDropDown";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../_constants/tutorialmessages/ManualMessages";

class ActivityForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
      metTableImage:
        "https://mufasa-qa.interswitchng.com/p/iswportal-v2/uat/apps/VLA/v1_0/static/media//MetTable.png",
      run: false,
      stepIndex: 0,
      steps: [
        {
          target: tourMessages.adminActivityForm.target,
          content: (
            <div>
              <p>{tourMessages.adminActivityForm.title}</p>
            </div>
          ),
          placement: "left",
          locale: { skip: "SKIP", close: "Next" },
        },
        tourMessages.default,
      ],
    };
  }

  showConfirmation = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  };
  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  handleSubmit = data => {
    const newMetData = parseFloat(data.metValue);

    let metricsIds = [];
    if (data.metrics && data.metrics.length) {
      metricsIds = data.metrics.map(interest => ({ id: interest.id }));
    }

    data = {
      ...data,
      metValue: newMetData,
      metrics: metricsIds,
    };

    this.props.submitAction(data);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitted) {
      this.resetForm();
    }
    if (nextProps.showNextJoyRide) {
      this.setState({ run: true });
      this.props.setNextJoyRide();
    }
  }

  resetForm = () => {
    this.refs.activityForm.reset();
  };

  reset = () => {
    this.props.reset();
    this.resetForm();
  };
  handleJoyrideCallback = data => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if ([STATUS.SKIPPED].includes(status)) {
        this.setState({ run: false });
      } else {
        this.props.startJoyRideAtDataTable();
      }
    }
  };
  render() {
    const { canSubmit , run, steps, stepIndex } = this.state;
    const {
      submitting,
      error,
      hasParams,
      selectedRow,
      isView,
      fetchingActivity,
      fetchingError,
    } = this.props;

    return (
      <div>
      <Joyride
          steps={steps}
          scrollToFirstStep
          showProgress
          showSkipButton
          styles={{
            options: {
              width: 200,
              height: 60,
              zIndex: 1000,
            },
          }}
          callback={this.handleJoyrideCallback}
          run={run}
          stepIndex={stepIndex}
        />
        <Modal isOpen={this.state.showModal} toggle={this.showConfirmation}>
          <ModalHeader toggle={this.showConfirmation}>
            Metabolic Equivalent (MET) Data
          </ModalHeader>

          <ModalBody>
            <Card>
              <CardImg
                top
                width="100%"
                height="100%"
                src={this.state.metTableImage}
              />
            </Card>
          </ModalBody>
        </Modal>

        <Row>
          <Col>
            <Card>
              <CardHeader>{hasParams ? "Edit" : "Create"} Activity</CardHeader>
              <CardBody>
                {error && !error.errors ? (
                  <UncontrolledAlert color="danger">
                    {error.message}
                  </UncontrolledAlert>
                ) : null}
                {error && error.errors && error.errors.length ? (
                  <UncontrolledAlert color="danger">
                    {error.errors.map((error, index) => (
                      <p key={index}>
                        <strong>{error.fieldName}: </strong>
                        {error.message}
                      </p>
                    ))}
                  </UncontrolledAlert>
                ) : null}
                {fetchingError ? (
                  <Alert color="danger">{fetchingError.message}</Alert>
                ) : null}

                {fetchingActivity && (
                  <Alert color="info">
                    <Spinner message="Fetching activity details" />
                  </Alert>
                )}

                <Formsy
                  ref="activityForm"
                  onValidSubmit={this.handleSubmit}
                  onValid={this.enableButton}
                  onInvalid={this.disableButton}
                  noValidate
                >
                  <TextInput
                    name="name"
                    value={selectedRow && hasParams ? selectedRow.name : null}
                    required
                    disabled={submitting || isView || fetchingActivity}
                    title="Activity"
                    validations={{
                      minLength: 3,
                      maxLength: 50,
                    }}
                    validationErrors={{
                      minLength: "Minimum of 3 characters allowed",
                      maxLength: "Maximum of 50 characters allowed",
                    }}
                  />
                  <TextInput
                    name="metValue"
                    value={
                      selectedRow && hasParams ? selectedRow.metValue : null
                    }
                    required
                    disabled={submitting || isView || fetchingActivity}
                    title="MET Value"
                    validations={{
                      isNumeric: true,
                    }}
                    validationErrors={{
                      isNumeric: "Enter number only",
                    }}
                    subtitle="
Click here to check common metabolic equivalent (MET) values"
                    cursor={true}
                    onLabelClick={this.showConfirmation}
                  />
                  <MetricsDropDown
                    isMulti={true}
                    isClearable={true}
                    name="metrics"
                    title="Metrics"
                    value={
                      selectedRow && hasParams ? selectedRow.metrics : null
                    }
                    selectedMetrics
                    valueKey="id"
                    disabled={submitting || isView || fetchingActivity}
                    innerRef={c => {
                      this.metrics = c;
                    }}
                    isRequired={true}
                  />
                  <Button
                    type="submit"
                    color="primary"
                    disabled={!canSubmit || submitting || isView}
                    className="pp1"
                  >
                    {submitting ? (
                      <Spinner size="sm" />
                    ) : (
                      <span>
                        {hasParams ? "Update" : "Create"} <MdAdd size={20} />
                      </span>
                    )}
                  </Button>{" "}
                  {hasParams ? (
                    <Button
                      type="button"
                      outline
                      color="primary"
                      onClick={() => this.reset()}
                    >
                      Reset
                    </Button>
                  ) : null}
                </Formsy>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ActivityForm;
